var NoResults = React.createClass({
  propTypes: {
    showResetFilters: React.PropTypes.bool,
    onFilterResetClicked: React.PropTypes.func,
    message: React.PropTypes.string
  },
  getDefaultProps() {
    return {
      showResetFilters: false,
      message: Labels.getLabel("No results were found for your search.")
    }
  },
  getResetLink() {
    return (
      <li>
        {Labels.getLabel("Try to")} <a role="button" href="#" onClick={this.props.onFilterResetClicked}>{Labels.getLabel("reset filters")}</a>
      </li>
    )
  },
  render() {
    return (
      <div className="no-results">
        <p>{this.props.message}</p>

        <ul className="bullet-list">
          {this.props.showResetFilters ? this.getResetLink() : null}
        </ul>
      </div>
    )
  }
})